module.exports = __webpack_public_path__ + "img/th.fb6342e0.png";